import {
  GridRenderCellParams,
  GridActionsCellItem,
} from "@mui/x-data-grid-pro";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

interface ToggleBooleanCellParams {
  params: GridRenderCellParams;
}

export const ToggleBooleanCell = (props: ToggleBooleanCellParams) => {
  const { params } = props;

  const startEditMode = () => {
    if (params.api.getRowMode(params.id) !== "edit") {
      params.api.startRowEditMode({ id: params.id });
    }
  };

  const stopEditMode = () => {
    if (params.api.getRowMode(params.id) !== "view") {
      params.api.stopRowEditMode({ id: params.id });
    }
  };

  const updateBooleanCell = (value: boolean) => {
    params.row[params.field] = value;
    params.row.status = "updated";
    params.api.updateRows([params.row]);
  };

  const handleYesClick = () => {
    startEditMode();
    updateBooleanCell(true);

    setTimeout(() => {
      stopEditMode();
    });
  };

  const handleNoClick = () => {
    startEditMode();
    updateBooleanCell(false);

    setTimeout(() => {
      stopEditMode();
    });
  };

  const backgroundColor = params.value ? "green" : "red";
  const unselectedColor = "lightgray";

  return (
    <>
      <GridActionsCellItem
        icon={<CheckIcon />}
        label="Yes"
        onClick={handleYesClick}
        style={{
          backgroundColor:
            params.value === true ? backgroundColor : unselectedColor,
        }}
      />
      <GridActionsCellItem
        icon={<ClearIcon />}
        label="No"
        onClick={handleNoClick}
        style={{
          backgroundColor:
            params.value === false ? backgroundColor : unselectedColor,
        }}
      />
    </>
  );
};
